import { FC, HTMLAttributes, useState } from "react"

import { FieldError } from '../../../../../widgets'
import { IDateTimeProps } from './IDateTimeProps'
import clsx from 'clsx'
import { useDateTimeValidationSchema } from './DateTimeValidationSchema'

interface IDateTimeFieldProps extends HTMLAttributes<HTMLInputElement>, IDateTimeProps { }

export const SimpleDateTime: FC<IDateTimeFieldProps> = (props) => {
    const { id, placeholder, value: initValue, className, title, readOnly, disabled } = props
    const schema = useDateTimeValidationSchema(props)
    const [error, setError] = useState<string>();
    const [value, setValue] = useState<string>(initValue || '');

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;
        setValue(inputValue)

        schema?.validate(inputValue)
            .then(() => setError(undefined))
            .catch((error) => setError(error.message))
    }

    return <>
        <input
            type='datetime-local'
            id={id}
            className={clsx(className, "form-control form-control-sm")}
            placeholder={placeholder}
            readOnly={readOnly}
            disabled={disabled}
            title={title}
            value={value}
            onChange={handleChange}
        />
        {error && <FieldError show={true} message={error} />}
    </>
}
